// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3fwQD","title":"ClientInsurance_title__tWLnb","itemText":"ClientInsurance_itemText__1Y_9e"};